import React, { Component, Suspense } from 'react';
import { Card, Form, Col, Button, Jumbotron, ButtonGroup, ToggleButton } from 'react-bootstrap';
import { CodingEventQueueService } from '../../services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { LinkContainer } from 'react-router-bootstrap';
import { TabList, TabItem } from '../../controls';
import moment from 'moment';
import { faEdit, faPlusCircle, faPlusSquare, faSquare, faWindowClose, faChevronCircleRight, faTimesCircle, faSave } from '@fortawesome/free-solid-svg-icons'
import { ConditionalRender } from '../../controls/formControls';

class CodingEventQueue extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { viewModel: { queue: { members: [] }, employeeUsers: [], accounts: [] }, editing: false };

        this.handleUserInput = this.handleUserInput.bind(this);
        this.handleUserIntInput = this.handleUserIntInput.bind(this);
        this.renderUserTable = this.renderUserTable.bind(this);
        this.addUserToTeam = this.addUserToTeam.bind(this);
        this.editUser = this.editUser.bind(this);
        this.removeUser = this.removeUser.bind(this);
        this.changeUserData = this.changeUserData.bind(this);
        this.changeUserIntData = this.changeUserIntData.bind(this);
        this.saveUser = this.saveUser.bind(this);
        this.getAvailableUsers = this.getAvailableUsers.bind(this);
        this.renderAccountTable = this.renderAccountTable.bind(this);
        this.saveQueue = this.saveQueue.bind(this);
        //this.renderCodingEventsTable = this.renderCodingEventsTable.bind(this);
    }

    async componentDidMount() {
        await this.getQueue();
    }

    async getQueue() {
        if (this.props.match.params.id !== undefined) {
            const queueService = new CodingEventQueueService();
            const queueId = this.props.match.params.id;
            const callResult = await queueService.getQueue(queueId);
            if (callResult.result) {
                this.setState({ viewModel: callResult.model, editing: false });
            }
        }
    }

    getAvailableUsers(userId) {
        var existing = this.state.viewModel.queue.members.map((user) => { return user.userId });
        //y.filter(e => !x.includes(e)) );
        var nonMembers = this.state.viewModel.employeeUsers.filter(r => !existing.includes(r.id) || r.id == userId);

        return nonMembers.map((u, idx) =>
            <option key={idx} value={u.id}>{u.fullName}</option>);
    }

    handleUserInput(event) {
        // taken straight from the React Docs
        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var partialState = { ...this.state.viewModel };
        partialState.queue[name] = value;
        this.setState({ viewModel: partialState, editing: true });
    }

    handleUserIntInput(event) {
        // taken straight from the React Docs
        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var partialState = { ...this.state.viewModel };
        partialState.queue[name] = parseInt(value);
        this.setState({ viewModel: partialState, editing: true });
    }

    addUserToTeam() {
        let viewModel = {...this.state.viewModel}
        viewModel.queue.members.unshift({
            userId: 0,
            codingEventQueueId: this.state.viewModel.queue.id,
            teamLead: false,
            new: true
        });
        this.setState({ viewModel: viewModel });
    }

    async saveQueue() {
        var queueService = new CodingEventQueueService();
        var queue = this.state.viewModel.queue;
        var result = await queueService.saveQueue({ id: queue.id, name: queue.name, state: queue.state });
        if (result.result) {

            this.setState({ editing: false }, () => this.getQueue());
        }
    }

    async removeUser(idx) {
        let viewModel = { ...this.state.viewModel }
        const user = viewModel.queue.members[idx];
        if (user.edit) {
            const queueService = new CodingEventQueueService();
            const callResult = await queueService.removeUser(viewModel.queue.id, user.userId);
            if (callResult.result) {
                viewModel.queue.members.splice(idx, 1);
            }
        } else {
            viewModel.queue.members.shift();
        }
        this.setState({ viewModel: viewModel, editing: false, editUserOrigValues: {} });
    }

    editUser(idx) {
        let viewModel = { ...this.state.viewModel }
        let editUserOrigValues = { ...viewModel.queue.members[idx] };
        viewModel.queue.members[idx].edit = true;
        this.setState({ viewModel: viewModel, editing: true, editUserOrigValues: editUserOrigValues });
    }

    changeUserData(event, idx) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var partialState = { ...this.state.viewModel };
        partialState.queue.members[idx][name] = value;
        this.setState({ viewModel: partialState, editing: true });
    }

    changeUserIntData(event, idx) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var partialState = { ...this.state.viewModel };
        partialState.queue.members[idx][name] = parseInt(value);
        this.setState({ viewModel: partialState, editing: true});
    }

    async saveUser(idx) {
        const queueService = new CodingEventQueueService();
        let partialState = {...this.state.viewModel}
        const user = partialState.queue.members[idx];
        const callResult = await queueService.addEditUser(user);
        if (callResult.result) {
            partialState.queue.members[idx] = callResult.model;
            this.setState({ viewModel: partialState, editing: false });
        }
    }
    renderAccountTable() {
        return (
                <table className="table table-striped table-hover">
                    <tr>
                        <th>Name</th>
                        <th className="table-fit">
                        </th>
                    </tr>
                {this.state.viewModel.accounts.map((account, idx) => 
                    <tr><td>{account.name}</td></tr>
                    )}

                </table>
            );
    }

    renderUserTable() {
        return (
            this.state.viewModel.queue.members.length > 0
                ? <table className="table table-striped table-hover">
                      <tr>
                          <th>Name</th>
                          <th>Role</th>
                        <th className="table-fit">
                            <Button variant="primary" size="sm" disabled={this.state.editing} onClick={() => this.addUserToTeam()}>Add</Button>
                        </th>
                      </tr>
                      {this.state.viewModel.queue.members.map((user, idx) =>
                          user.edit ? <tr className="bg-light">
                                          <td>{user.userFullName}</td>
                                            <td className="align-middle">
                                              <Form.Check type="checkbox"
                                                          label="Team Lead"
                                                          name="teamLead"
                                                          id={"teamLead" + user.userId}
                                                          checked={user.teamLead}
                                                          onChange={(e) => this.changeUserData(e, idx)} />
                              </td>
                              <td className="table-fit">
                                  <FontAwesomeIcon icon={faWindowClose} onClick={() => this.removeUser(idx)} className="gray-icon" />&nbsp;
                                  <FontAwesomeIcon icon={faSave} onClick={() => this.saveUser(idx)} disabled={user.userId === 0} className="success-icon" />
                                          </td>
                                      </tr> :
                              user.new ? <tr className="bg-light">
                                         <td>
                                      <Form.Control as="select"
                                                    size="sm"
                                                           value={user.userId}
                                          name="userId"
                                                          style={{maxWidth: "300px"}}
                                          id={"userId" + user.id}
                                                           onChange={(e) => this.changeUserIntData(e, idx)}>
                                          <option key={null} value={0}>Select user...</option>
                                          {this.getAvailableUsers(user.userId)}
                                      </Form.Control>
                                  </td>
                                  <td className="align-middle">
                                         <Form.Check type="checkbox"
                                                     label="Team Lead"
                                          name="teamLead"
                                                     id={"teamLead" + user.userId}
                                                     checked={user.teamLead}
                                                     onChange={(e) => this.changeUserData(e, idx)} />
                                  </td>
                                  <td className="table-fit align-middle">
                                      <FontAwesomeIcon icon={faWindowClose} onClick={() => this.removeUser(idx)} className="gray-icon" />&nbsp;
                                      <FontAwesomeIcon icon={faSave} onClick={() => this.saveUser(idx)} className={user.userId === 0 ? "d-none" : "success-icon"} />
                                  </td>
                              </tr> :
                          <tr>
                                      <td>{user.userFullName}</td>
                              <td>{user.teamLead ? "Team Lead" : "Member"}</td>
                                      <td className="table-fit">
                                          <FontAwesomeIcon icon={faEdit} onClick={() => this.editUser(idx)} className={this.state.editing ? "d-none" : "success-icon"} />
                                      </td>
                          </tr>)}
                </table> : <Button variant="primary" size="sm" disabled={this.state.editing} onClick={() => this.addUserToTeam()}>Add</Button>
);
}

    render() {
        return (
            <Card>
                <Card.Header className="d-flex align-items-center">
                    <div className="mr-auto">{this.state.viewModel.queue.name}</div>
                    <div className="card-btn-group">
                        <LinkContainer to={'/admin/codingqueues'}>
                            <Button variant="secondary" size="sm">Close</Button>
                        </LinkContainer>
                        <ConditionalRender visible={this.state.editing}>
                            <Button variant="primary" size="sm" onClick={() => this.saveQueue()}>Save</Button>
                        </ConditionalRender>
                    </div>
                </Card.Header>
                <Card.Body>
                    {JSON.stringify(this.state.editing, undefined, 2)}
                    <Form.Row>
                        <Form.Group as={Col} lg="6" md="12" controlId="name">
                            <Form.Label>Name</Form.Label>
                            <Form.Control placeholder="" name="name" id="name" value={this.state.viewModel.queue.name} onChange={this.handleUserInput}/>
                        </Form.Group>
                        <Form.Group as={Col} lg="3" md="6" controlId="state">
                            <Form.Label className="btn-group-label"
                                        data-type="number">State</Form.Label>
                            <ButtonGroup toggle>
                                <ToggleButton
                                    type="radio"
                                    variant="secondary"
                                    name="state"
                                    data-type="number"
                                    value={100}
                                    checked={this.state.viewModel.queue.state === 100}
                                    onChange={this.handleUserIntInput}>
                                    Active
                                </ToggleButton>
                                <ToggleButton
                                    type="radio"
                                    variant="secondary"
                                    name="state"
                                    data-type="number"
                                    value={-50}
                                    checked={this.state.viewModel.queue.state === -50}
                                    onChange={this.handleUserIntInput}>
                                    Suspended
                                </ToggleButton>
                                <ToggleButton
                                    type="radio"
                                    variant="secondary"
                                    name="state"
                                    data-type="number"
                                    value={-100}
                                    checked={this.state.viewModel.queue.state === -100}
                                    onChange={this.handleUserIntInput}
                                >
                                    Deleted
                                </ToggleButton>
                            </ButtonGroup>
                        </Form.Group>
                    </Form.Row>
                    <TabList>
                        <TabItem label="Accounts">
                            {this.renderAccountTable()}
                        </TabItem>
                        <TabItem label="Team Members" className="card-body-table">
                            {this.renderUserTable()}
                        </TabItem>
                        {/*<TabItem label="Coding Events">*/}
                        {/*    {this.renderCodingEventsTable()}*/}
                        {/*</TabItem>*/}
                    </TabList>
                    <pre>
                                {
                                    //JSON.stringify(this.state.viewModel, null, 2)
                                }
                            </pre>
                </Card.Body>
            </Card>
        );
    }

}

export default CodingEventQueue;